export const UPDATE_QUICKLOGIN_INFOS = 'UPDATE_QUICKLOGIN_INFOS';
export const RESET_QUICKLOGIN_INFOS = 'RESET_QUICKLOGIN_INFOS';
